import { render, staticRenderFns } from "./PromotionBanner.vue?vue&type=template&id=71dbc888&"
import script from "./PromotionBanner.vue?vue&type=script&lang=js&"
export * from "./PromotionBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports